<template>
  <div>
    <v-row no-gutters>
      <v-col sm="8" class="pa-0">
        <h2>Approval Settings</h2>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col class="pa-0">
        <DiscoveryTool/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import PreferencesService from '@/services/PreferencesService';
import DiscoveryTool from '@/components/SysSettings/Miscellaneous/DiscoveryTool';
export default {
  components: { DiscoveryTool },
  props: ['title'],
};
</script>
